import * as React from 'react';
import * as styles from '../../styles.css';

import { UIHeading2 } from '@cian/ui-kit';

interface ITitleServicesProps {
  title: string;
}

export const TitleServices: React.FC<ITitleServicesProps> = ({ title }) => {
  return (
    <div className={styles['title']}>
      <UIHeading2>{title}</UIHeading2>
    </div>
  );
};

TitleServices.displayName = 'TitleServices';
